import './style.scss';
import Label from 'components/atoms/Label';
import Input from 'components/atoms/Input';
import Select from 'react-select';
import Textarea from 'components/atoms/Textarea';

const FieldType = (props) => {
  const { type, className, classNamePrefix, id, value, disabled, onChange, options, placeholder, defaultValue, components } = props;

  if (type === "text" || type === "email") {
    return (
      <Input
        className={className}
        name={id}
        id={id}
        type={type}
        value={value}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
      />
    );
  } else if (type === "textarea") {
    return (
      <Textarea
        className={className}
        name={id}
        id={id}

        onChange={onChange}
        placeholder={placeholder}
      >{value}</Textarea>
    );
  } else if (type === "select") {
    if (!options) return false;
    return (
      <Select
        id={id}
        className={"Select " + className}
        classNamePrefix={classNamePrefix}
        options={options}
        placeholder={placeholder}
        isSearchable
        onChange={onChange}
      />
    );
  } else if (type === "multiselect") {
    if (!options) return false;
    return (
      <Select
        id={id}
        className={"Select " + className}
        classNamePrefix={classNamePrefix}
        options={options}
        placeholder={placeholder}
        isMulti
        isClearable
        isSearchable
        onChange={onChange}
        defaultValue={defaultValue}
        value={value}
        components={components}
      />
    );
  } else {
    return false;
  }
}

function Field(props) {
  const { className, classNamePrefix } = props;

  return (
    <div className={"Field " + className}>
      <Label
        className={classNamePrefix + "__label"}
        htmlFor={props.id}
        label={props.name}
      />
      <FieldType
        id={props.id}
        className={classNamePrefix + "__field"}
        classNamePrefix={classNamePrefix}
        name={props.name}
        type={props.type}
        value={props.value}
        disabled={props.disabled}
        onChange={props.onChange}
        options={props.options}
        placeholder={props.placeholder}
        components={props.components}
        defaultValue={props.defaultValue}
      />
      {props.validation}
    </div>);
}

Field.defaultProps = {
  className: "",
  classNamePrefix: "Field",
}

export default Field;